<template>
  <div class="mt-12 px-14">

    <div class="accordium" :options="options" v-if="block.options.slide_type == 'accordium'">
      <div class="entry border-b-2" v-for="b in get_slider_blocks" :key="b.id" @click="b.display = !b.display">
        <div class="header items-center bg-black text-white cursor-pointer py-3 px-2 flex justify-between">
          <span :class="{
            'text-3xl': b.options.title_format == 'H1',
            'text-2xl': b.options.title_format == 'H2',
            'text-xl': b.options.title_format == 'H3'
          }" v-html="b.title"></span>
          <span class="down fill-current" v-if="!b.display">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"/></svg>
          </span>
          <span class="up fill-current" v-if="b.display">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg>
          </span>
        </div>
        <div class="content p-2 transition-all" v-show="b.display" v-html="b.content"></div>
      </div>
    </div>

    <splide v-else :options="options" class="flex items-center place-items-center bg-white">
      <splide-slide v-for="b in get_slider_blocks" :key="b.id">
        <component :is="`block-${b.type_of_block.replace('_','-')}`" :block="b"></component>
      </splide-slide>
    </splide>

    <pre v-if="debug">
      {{ block }}
      {{ get_slider_blocks }}
    </pre>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { Splide, SplideSlide } from '@splidejs/vue-splide'

import BlockTitleText from './title_text.vue'
import BlockText from './text.vue'
import BlockVideo from './video.vue'
import BlockImage from './image.vue'
import BlockTextImage from './text_image.vue'

export default {
  data() {
    return {
      debug: false,
			  options: {
			  	rewind : true,
				  width  : 800,
				  perPage: 1,
				  gap    : '1rem',
			  },    }
  },
  props: [ 'block' ],
  methods: {
    moved( splide, newIndex ) {
			// console.log( 'moved', newIndex );
		},
  },
  computed: {
    ...mapGetters(['sub_blocks']),
    get_slider_blocks() {
      return this.sub_blocks( this.block.id )
    }
  },
  components: {
    Splide,
    SplideSlide,
    BlockTitleText,
    BlockText,
    BlockTextImage,
    BlockVideo,
    BlockImage,
  }
}
</script>
